import React from 'react';
import {
    DiscoverButtonContainer,
    InformationSectionContainer,
    InformationSectionDescription,
    InformationSectionDevicesSvgContainer,
    InformationSectionTextContainer,
    InformationSectionTitle
} from './PageInformationStyle';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import { ReactComponent as UbisoftPlusLogo } from '../../assets/ubisoft_plus_logo.svg';
import { GotoHomepageButtonContainer } from '../UI/Buttons/GoToHomepageButton/GotoHomepageButtonContainer';

const PageInformationContainer = ({ context }: IContext) => {
    return (
        <InformationSectionContainer>
            <InformationSectionTextContainer>
                <InformationSectionDevicesSvgContainer>
                    <UbisoftPlusLogo />
                </InformationSectionDevicesSvgContainer>
                <InformationSectionTitle
                    dangerouslySetInnerHTML={{ __html: context.title }}
                />
                <InformationSectionDescription
                    dangerouslySetInnerHTML={{ __html: context.description }}
                />
                <DiscoverButtonContainer>
                    <GotoHomepageButtonContainer
                        context={context}
                    />
                </DiscoverButtonContainer>
            </InformationSectionTextContainer>
        </InformationSectionContainer>
    );
};

export default withContent(PageInformationContainer);
